import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { HardHat, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — sign in with your new password");
      navigate("/portal/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#0B1B3D] flex items-center justify-center px-5 relative grain">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-10">
          <span className="w-12 h-12 bg-[#005AE0] flex items-center justify-center"><HardHat className="w-6 h-6 text-white" /></span>
          <div className="font-heading text-white">
            <p className="font-extrabold text-lg leading-none">NOYOLA</p>
            <p className="text-[11px] tracking-[0.28em] opacity-70">CONSTRUCTION LLC</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white p-8 md:p-10" data-testid="reset-password-form">
          <div className="flex items-center gap-2 mb-8">
            <KeyRound className="w-4 h-4 text-[#005AE0]" />
            <h1 className="font-heading font-bold text-[#0B1B3D] text-xl">Set a New Password</h1>
          </div>
          <label className="field-label">New Password (min. 8 characters)</label>
          <input className="field mb-5" type="password" minLength={8} data-testid="reset-password-input"
            value={password} onChange={(e) => setPassword(e.target.value)} required />
          <label className="field-label">Confirm New Password</label>
          <input className="field mb-8" type="password" data-testid="reset-confirm-input"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          <button type="submit" disabled={busy} data-testid="reset-submit-btn" className="btn-primary w-full">
            {busy ? "Saving…" : "Update Password"}
          </button>
          <Link to="/portal/login" className="block text-center text-sm text-[#005AE0] mt-5">Back to login</Link>
        </form>
      </div>
    </div>
  );
}
